export default "/assets/site/images/mavir_logo.png?f04c0a373fbff5615bdb0874e69c8f48";